import { render } from "./ClientPage.vue?vue&type=template&id=422d7d6e"
import script from "./ClientPage.vue?vue&type=script&lang=js"
export * from "./ClientPage.vue?vue&type=script&lang=js"

import "@/css/ClientPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__